import React, { useState } from 'react';

function Generator() {
  const [businessType, setBusinessType] = useState('restaurant');
  const [shopName, setShopName] = useState('');
  const [imageContent, setImageContent] = useState('');
  const [shopFeatures, setShopFeatures] = useState('');
  const [targetCustomers, setTargetCustomers] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [generatedTexts, setGeneratedTexts] = useState([]);
  const [selectedTextIndex, setSelectedTextIndex] = useState(-1);
  const [error, setError] = useState('');

  // ファイル選択時の処理
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
      };
      fileReader.readAsDataURL(file);
    }
  };

  // フォーム送信時の処理
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!shopName) {
      setError('店舗名を入力してください');
      return;
    }
    
    if (!selectedFile) {
      setError('画像をアップロードしてください');
      return;
    }
    
    setError('');
    setIsLoading(true);
    
    try {
      // バックエンドAPIが実装されるまでダミーデータを使用
      setTimeout(() => {
        const dummyTexts = [
          `${shopName}の魅力が詰まった${imageContent}！${shopFeatures}を活かした特別な一品をぜひお試しください。#${businessType} #${imageContent}`,
          `今日のおすすめは${imageContent}です。${shopFeatures}の風味が絶妙にマッチした逸品。ぜひご来店お待ちしております！#今日のおすすめ #${imageContent}`,
          `【新登場】${shopFeatures}を使った${imageContent}が登場！${shopName}ならではの味わいをお楽しみください。期間限定でのご提供です。#新メニュー #${imageContent}`
        ];
        setGeneratedTexts(dummyTexts);
        setIsLoading(false);
      }, 2000);
      
      // 実際のAPI実装時はこちらを使用
      // const formData = new FormData();
      // formData.append('businessType', businessType);
      // formData.append('shopName', shopName);
      // formData.append('imageContent', imageContent);
      // formData.append('shopFeatures', shopFeatures);
      // formData.append('targetCustomers', targetCustomers);
      // formData.append('image', selectedFile);
      // 
      // const response = await fetch('/api/generate', {
      //   method: 'POST',
      //   body: formData,
      // });
      // 
      // const data = await response.json();
      // 
      // if (data.success && data.variations) {
      //   setGeneratedTexts(data.variations);
      // } else {
      //   throw new Error(data.error || '投稿文の生成に失敗しました');
      // }
    } catch (error) {
      console.error('Error:', error);
      setError(error.message || '投稿文の生成中にエラーが発生しました');
      setIsLoading(false);
    }
  };

  // テキスト選択時の処理
  const handleTextSelect = (index) => {
    setSelectedTextIndex(index);
  };

  // 選択したテキストをコピーする処理
  const handleCopyText = () => {
    if (selectedTextIndex >= 0 && selectedTextIndex < generatedTexts.length) {
      navigator.clipboard.writeText(generatedTexts[selectedTextIndex])
        .then(() => {
          alert('テキストをクリップボードにコピーしました');
        })
        .catch((err) => {
          console.error('コピーに失敗しました:', err);
        });
    }
  };

  // フォームをリセットする処理
  const handleReset = () => {
    setShopName('');
    setImageContent('');
    setShopFeatures('');
    setTargetCustomers('');
    setSelectedFile(null);
    setPreviewUrl('');
    setGeneratedTexts([]);
    setSelectedTextIndex(-1);
    setError('');
  };

  return (
    <div className="generator-container">
      <h1>投稿文を生成</h1>
      <a href="/" className="back-link">ホームに戻る</a>
      
      <div className="generator-content">
        {generatedTexts.length === 0 ? (
          <div className="input-form-container">
            <h2>投稿情報を入力</h2>
            
            <form onSubmit={handleSubmit} className="input-form">
              <div className="form-group">
                <label htmlFor="businessType">業種</label>
                <select 
                  id="businessType" 
                  value={businessType} 
                  onChange={(e) => setBusinessType(e.target.value)}
                >
                  <option value="restaurant">飲食店</option>
                  <option value="beauty">美容室</option>
                  <option value="retail">小売店</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="shopName">店舗名 *</label>
                <input 
                  type="text" 
                  id="shopName" 
                  value={shopName} 
                  onChange={(e) => setShopName(e.target.value)} 
                  placeholder="例: カフェAI" 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="imageUpload">写真アップロード *</label>
                <input 
                  type="file" 
                  id="imageUpload" 
                  accept="image/*" 
                  onChange={handleFileChange} 
                  required 
                />
                {previewUrl && (
                  <div className="image-preview">
                    <img src={previewUrl} alt="プレビュー" />
                  </div>
                )}
              </div>
              
              <div className="form-group">
                <label htmlFor="imageContent">写真の内容</label>
                <input 
                  type="text" 
                  id="imageContent" 
                  value={imageContent} 
                  onChange={(e) => setImageContent(e.target.value)} 
                  placeholder="例: 季節のパスタ、店内装飾" 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="shopFeatures">店舗の特徴</label>
                <textarea 
                  id="shopFeatures" 
                  value={shopFeatures} 
                  onChange={(e) => setShopFeatures(e.target.value)} 
                  placeholder="例: オーガニック食材にこだわった料理、落ち着いた雰囲気" 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="targetCustomers">ターゲット顧客</label>
                <input 
                  type="text" 
                  id="targetCustomers" 
                  value={targetCustomers} 
                  onChange={(e) => setTargetCustomers(e.target.value)} 
                  placeholder="例: 30-40代女性、カップル" 
                />
              </div>
              
              {error && <div className="error-message">{error}</div>}
              
              <div className="form-actions">
                <button type="submit" className="submit-btn" disabled={isLoading}>
                  {isLoading ? '生成中...' : '投稿文を生成'}
                </button>
                <button type="button" className="reset-btn" onClick={handleReset}>リセット</button>
              </div>
            </form>
          </div>
        ) : (
          <div className="results-container">
            <h2>生成された投稿文</h2>
            
            <div className="generated-texts">
              {generatedTexts.map((text, index) => (
                <div 
                  key={index} 
                  className={`text-option ${selectedTextIndex === index ? 'selected' : ''}`}
                  onClick={() => handleTextSelect(index)}
                >
                  <h3>投稿文 {index + 1}</h3>
                  <p>{text}</p>
                </div>
              ))}
            </div>
            
            <div className="result-actions">
              <button 
                className="copy-btn"
                onClick={handleCopyText} 
                disabled={selectedTextIndex < 0}
              >
                選択した投稿文をコピー
              </button>
              <button className="back-btn" onClick={() => setGeneratedTexts([])}>
                別の投稿文を生成
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Generator;
